import { gql } from '@apollo/client'
import { ShiftPlannedHubReturnServiceBreakLocationFragmentDoc } from './fragment/shiftPlannedHubReturnServiceBreakLocation.hook'
import { PlannedHubReturnShiftSectionStateFragmentDoc } from './shiftSetPlannedHubReturnSection.hook'

// Since typescript-react-apollo v5 the generated fragment docs no longer embed the
// fragments they spread, so cache.readFragment/writeFragment throw "No fragment named ...".
// Operation docs are unaffected; only direct cache access needs this self-contained doc.
export const PlannedHubReturnShiftSectionStateCacheFragmentDoc = gql`
  ${PlannedHubReturnShiftSectionStateFragmentDoc}
  ${ShiftPlannedHubReturnServiceBreakLocationFragmentDoc}
`

export const PLANNED_HUB_RETURN_SHIFT_SECTION_STATE_FRAGMENT_NAME =
  'plannedHubReturnShiftSectionState'
